import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isExternalClientPath } from "../login-destination";
import { useSession } from "../session-context";

export function ProtectedRoute() {
  const { session, loading } = useSession();
  const location = useLocation();
  if (loading) {
    return (
      <main className="centered-state" aria-busy="true">
        <span className="spinner" aria-hidden="true" />
        <p>Opening your workspace…</p>
      </main>
    );
  }
  if (!session)
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search + location.hash }}
      />
    );
  if (session.roles.includes("external_client") && !isExternalClientPath(location.pathname)) {
    return <Navigate to="/client-projects" replace />;
  }
  return <Outlet />;
}
